document.addEventListener("DOMContentLoaded", () => {
  const isMobileScreen = () => window.innerWidth <= 992;

  let currentMode = ""; // Track the current mode to avoid unnecessary resets

  const toggleBehavior = () => {
    const container = document.querySelector(".product-tabs-accordion");
    if (!container) return; // Stop if no matching container found

    const tabList = container.querySelector(".product-tab__list");
    const tabContents = container.querySelectorAll(".product-tab__content");
    const buttons = tabList.querySelectorAll(".product-tab__button");
    const itemsContainer = container.querySelector(".product-tab__items");

    if (isMobileScreen() && currentMode !== "mobile") {
      currentMode = "mobile"; // Update the current mode
      tabList.classList.add("accordion-mode");

      // Reset tabs for accordion
      tabContents.forEach((content) => content.classList.remove("is-tab-active"));
      buttons.forEach((button) => {
        button.classList.remove("is-tab-active");

        const targetId = button.getAttribute("data-id");
        const content = document.getElementById(targetId);

        if (!content) return;

        // Ensure content is placed directly after the button
        if (!button.nextElementSibling || button.nextElementSibling !== content) {
          button.after(content);
        }

        // Add event listener for accordion behavior
        button.onclick = () => {
          const isActive = button.classList.contains("is-tab-active");

          // Toggle active state
          if (isActive) {
            button.classList.remove("is-tab-active");
            content.classList.remove("is-tab-active");
          } else {
            buttons.forEach((b) => b.classList.remove("is-tab-active"));
            tabContents.forEach((c) => c.classList.remove("is-tab-active"));

            button.classList.add("is-tab-active");
            content.classList.add("is-tab-active");
          }
        };
      });
    } else if (!isMobileScreen() && currentMode !== "desktop") {
      currentMode = "desktop"; // Update the current mode
      tabList.classList.remove("accordion-mode");

      // Reset accordion layout for desktop
      tabContents.forEach((content) => {
        content.classList.remove("is-tab-active");
        if (itemsContainer && content.parentElement !== itemsContainer) {
          itemsContainer.append(content);
        }
      });

      buttons.forEach((button) => {
        button.classList.remove("is-tab-active");

        const targetId = button.getAttribute("data-id");
        const content = document.getElementById(targetId);

        if (!content) return;

        // Add event listener for tab behavior
        button.onclick = () => {
          buttons.forEach((b) => b.classList.remove("is-tab-active"));
          tabContents.forEach((c) => c.classList.remove("is-tab-active"));

          button.classList.add("is-tab-active");
          content.classList.add("is-tab-active");
        };
      });

      // Activate the first tab by default (desktop only)
      const firstButton = tabList.querySelector(".product-tab__button");
      if (firstButton) {
        firstButton.click();
      }
    }
  };

  // Throttle resize events to prevent frequent calls
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      toggleBehavior();
    }, 200); // Adjust the debounce delay as needed
  });

  // Initial load
  toggleBehavior();
});
